import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Grid, TextField, Typography, Button, SnackbarContent } from '@material-ui/core';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import Snackbar from '@mui/material/Snackbar';
import Stack from '@mui/material/Stack';
import CustomSwitch from '../../../components/Common/Switch';
import { createNewOrganization, updateOrganization } from '../../../services/killshot';

const styles = makeStyles(() => ({
  disableTextStyle: {
    fontStyle: 'italic',
    color: '#A8A8A8',
  },
  gridContainers: {
    justifyContent: 'space-between',
    height: '100%',
  },
  customSwitchLabel: {
    fontSize: '14px',
    marginLeft: '25px',
  },
  buttons: {
    width: '82px',
    height: '32px',
    '&.Mui-disabled': {
      backgroundColor: '#D4D4D4',
      fontStyle: 'italic',
      color: '#A8A8A8',
    },
  },
  cancelButton: {
    backgroundColor: '#E9E9E9',
    color: '#7D7D7D',
  },
  snackBarDark: {
    backgroundColor: '#001C0A',
  },
  snackBarLight: {
    backgroundColor: '#E3F4E9',
  },
  iconStyle: {
    color: '#16A34A',
  },
  textFieldStyles: {
    '& .MuiInput-underline.Mui-disabled:before': { borderBottomStyle: 'solid' },
  },
}));

const SetNewOrg = props => {
  const {
    includePrimeBrokerage,
    isDisable,
    isEdit,
    killshotOrgs,
    orgState,
    clearOrgState,
    setCreateEditOrgDisable,
    setIncludePrimeBrokerage,
    setOrgState,
    setRows,
  } = props;

  const snackBarCreatetMsg = 'New Organization created successfully.';
  const snackBarUpdateMsg = 'Organización updated successfully.';

  const orgNamesArray = killshotOrgs.map(item => item.name.toUpperCase());
  const orgTagsArray = killshotOrgs.map(item => item.tag.toUpperCase());

  const [isSaveButtonDisable, setIsSaveButtonDisable] = useState(true);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarMsg, setSnackBarMsg] = useState('');
  const [textFieldNameError, setTextFieldNameError] = useState(false);
  const [textFieldTagError, setTextFieldTagError] = useState(false);

  const theme = useTheme();
  const classes = styles();

  const timerDuration = 6000;

  const switchHanldeOnChange = () => {
    setIncludePrimeBrokerage(!includePrimeBrokerage);
  };

  const updateTableContent = () => {
    if (isEdit) {
      const indexToUpdate = killshotOrgs.findIndex(item => item.id === orgState.id);
      killshotOrgs[indexToUpdate] = {
        ...killshotOrgs[indexToUpdate],
        id: orgState?.id,
        name: orgState?.orgName,
        tag: orgState?.orgTag,
        includeInPrime: includePrimeBrokerage,
      };
    } else {
      killshotOrgs.push({
        id: orgState?.id,
        name: orgState?.orgName,
        tag: orgState?.orgTag,
        includeInPrime: includePrimeBrokerage,
      });
      setRows(killshotOrgs);
    }
  };

  const handleCancelOnClick = () => {
    clearOrgState();
    setCreateEditOrgDisable(true);
  };

  const handleSaveOnClick = async () => {
    let response = null;
    if (isEdit) {
      response = updateOrganization(orgState?.id, orgState?.orgName, orgState?.orgTag, includePrimeBrokerage);
      setSnackBarMsg(snackBarUpdateMsg);
    } else {
      response = await createNewOrganization(orgState?.orgName, orgState?.orgTag, includePrimeBrokerage);
      setSnackBarMsg(snackBarCreatetMsg);
    }
    if (response) {
      setSnackBarOpen(true);
      updateTableContent();
      handleCancelOnClick();
    }
  };

  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackBarOpen(false);
  };

  const buttonDisableHandler = () => {
    const isOrgNameEmpty = !orgState?.orgName || orgState?.orgName.trim() === '';
    const isOrgTagEmpty = !orgState?.orgTag || orgState?.orgTag.trim() === '';

    setIsSaveButtonDisable(isOrgNameEmpty || isOrgTagEmpty);
  };

  const orgTagOnChange = e => {
    setOrgState({ ...orgState, orgTag: e?.target?.value });
  };

  const orgNameOnChange = e => {
    setOrgState({ ...orgState, orgName: e?.target?.value });
  };

  useEffect(() => {
    buttonDisableHandler();

    let isOrgNameDuplicate = false;
    let isOrgTagDuplicate = false;

    if (isEdit) {
      const origOrg = killshotOrgs.find(item => item.id === orgState.id);
      isOrgNameDuplicate =
        origOrg.name.toUpperCase() !== orgState?.orgName.toUpperCase() &&
        orgNamesArray.includes(orgState?.orgName.toUpperCase());
      isOrgTagDuplicate =
        origOrg.tag.toUpperCase() !== orgState?.orgTag.toUpperCase() &&
        orgTagsArray.includes(orgState?.orgTag.toUpperCase());
    } else {
      isOrgNameDuplicate = orgNamesArray.includes(orgState?.orgName.toUpperCase());
      isOrgTagDuplicate = orgTagsArray.includes(orgState?.orgTag.toUpperCase());
    }

    setTextFieldNameError(isOrgNameDuplicate);
    setTextFieldTagError(isOrgTagDuplicate);
  }, [orgState?.orgName, orgState?.orgTag]);

  const savedMesasge = (
    <Stack>
      <Snackbar
        open={snackBarOpen}
        autoHideDuration={timerDuration}
        onClose={handleSnackBarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <SnackbarContent
          className={theme.palette.type === 'dark' ? classes.snackBarDark : classes.snackBarLight}
          style={{ paddingLeft: '10px', minWidth: '298px', height: '39px' }}
          message={
            <Grid container direction="column" style={{ marginTop: '-7px' }}>
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item>
                    <CheckCircleIcon className={classes.iconStyle} style={{ fontSize: '19px', marginTop: '3px' }} />
                  </Grid>
                  <Grid item style={{ padding: '0px 10px 0px 10px' }}>
                    <Typography
                      style={{ color: '#16A34A', fontSize: '12px', fontWeight: '400' }}
                      variant="body1"
                      dangerouslySetInnerHTML={{
                        __html: snackBarMsg,
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <CloseIcon
                      className={classes.iconStyle}
                      style={{ fontSize: '17px', marginTop: '3px' }}
                      onClick={() => {
                        setSnackBarOpen(false);
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          }
        />
      </Snackbar>
    </Stack>
  );

  return (
    <>
      <div style={{ height: '100%' }}>
        <Grid container direction="column" className={classes.gridContainers}>
          <Grid item>
            <Typography
              style={{ fontSize: '20px', fontWeight: '400' }}
              className={isDisable ? classes.disableTextStyle : ''}
            >
              Set New Organization
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              className={isDisable ? classes.disableTextStyle : ''}
              style={{ fontSize: '14px', fontWeight: '400' }}
            >
              Both Organization Name and Organizaton tag are required.
              <br />
              Please make sure to click SAVE to apply changes.
            </Typography>
          </Grid>
          <Grid item>
            <Grid container direction="row">
              <Grid item xs={6} style={{ paddingRight: '25px' }}>
                <TextField
                  style={{ width: '100%' }}
                  label={<Typography>Organization Name</Typography>}
                  onChange={orgNameOnChange}
                  disabled={isDisable}
                  value={orgState?.orgName}
                  error={textFieldNameError}
                  helperText={textFieldNameError ? 'An organitzation with that name already exists.' : null}
                  className={classes.textFieldStyles}
                />
              </Grid>
              <Grid item xs={6} style={{ paddingLeft: '25px' }}>
                <TextField
                  style={{ width: '100%' }}
                  label={<Typography>Organization tag</Typography>}
                  onChange={orgTagOnChange}
                  disabled={isDisable}
                  value={orgState?.orgTag}
                  error={textFieldTagError}
                  helperText={textFieldTagError ? 'Tag already associated with another organization.' : null}
                  className={classes.textFieldStyles}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container>
              <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                <CustomSwitch
                  isChecked={includePrimeBrokerage}
                  isEnabled={!isDisable}
                  onChange={switchHanldeOnChange}
                  label="Show in Prime Brokerage"
                  labelClassName={`${classes.customSwitchLabel} ${isDisable ? classes.disableTextStyle : ''}`}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container direction="row" spacing={3} style={{ justifyContent: 'flex-end' }}>
              <Grid item>
                <Button
                  disabled={isDisable}
                  variant="contained"
                  onClick={handleCancelOnClick}
                  className={`${classes.buttons} ${classes.cancelButton}`}
                >
                  <Typography style={{ paddingTop: '2px' }}>CANCEL</Typography>
                </Button>
              </Grid>
              <Grid item>
                <Button
                  disabled={isSaveButtonDisable || textFieldNameError || textFieldTagError}
                  variant="contained"
                  color="primary"
                  onClick={handleSaveOnClick}
                  className={classes.buttons}
                >
                  <Typography style={{ paddingTop: '2px' }}>SAVE</Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      {savedMesasge}
    </>
  );
};

SetNewOrg.propTypes = {
  includePrimeBrokerage: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  isDisable: PropTypes.bool.isRequired,
  killshotOrgs: PropTypes.array.isRequired,
  orgState: PropTypes.object.isRequired,
  clearOrgState: PropTypes.func.isRequired,
  setCreateEditOrgDisable: PropTypes.func.isRequired,
  setIncludePrimeBrokerage: PropTypes.func.isRequired,
  setOrgState: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
};

export default SetNewOrg;
